<template>
<div class="container">
    
    <h1>{{ title }}</h1>
    <div style="height:25px" aria-hidden="true"></div>
    <p>如需要联系，请加qq或者选择留言</p>
    <p>QQ：2015901453</p>

    <div class="form-container">
        <form action="#" method="POST">
            <!-- 文本输入框 -->
            <!-- <div class="form-group">
                <label for="name">您的姓名</label>
                <input type="text" id="name" name="name" placeholder="请输入您的姓名" required>
            </div> -->

            <!-- 留言多行文本框 -->
            <div class="form-group">
                <label for="message">留言内容</label>
                <textarea 
                    id="message" 
                    name="message" 
                    placeholder="请输入您的留言..."
                    required></textarea>
            </div>

            <button type="submit">提交留言</button>
        </form>
    </div>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <!--Start rollercoin.com code-->
    <a href="https://rollercoin.com/?r=lk0qxc8o">
        <img src="https://static.rollercoin.com/static/img/ref/gen2/w970h90.gif" alt="970h90"/>
    </a>
    <!--End rollercoin.com code-->
					
  </div>
</template>

<script>
export default{
    name: 'MyContact',
    data(){
        // data 必须是一个函数，以避免多个实例间的数据共享
        return {
            title: '联系方式',
            
        }
    },
    methods: {
    // 定义事件处理函数
        updateTitle(newTitle) {
        this.title = newTitle;
        }
    },
    mounted() {
        // 组件挂载到 DOM 后执行
        console.log('组件已挂载');
    }
}
</script>

<style scoped>

.container {
    padding: 20px;
    background-color: #2f3045;
    color: #fff;
    max-width: 1200px;
    margin: 20px auto;
    width: 100%;
    box-sizing: border-box;
}

.form-container {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    width: 100%;
    max-width: 500px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #555;
}

input[type="text"],
textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
    transition: border-color 0.3s;
}

input[type="text"]:focus,
textarea:focus {
    outline: none;
    border-color: #3498db;
}

textarea {
    resize: vertical; /* 允许垂直调整大小 */
    min-height: 150px;
}

button {
    background-color: #3498db;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
}

button:hover {
    background-color: #2980b9;
}

</style>